<template>
  <generic-triangle-print
    :type="polygonalChartType"
    :data="data"
    :norm="norm"
    :coordinates="triangleCoordinates">
      <template #coordinates>
        %C₂H₂ = {{ formatNumberValue(data.data.percentageC2H2) }} |
        %C₂H₄ = {{ formatNumberValue(data.data.percentageC2H4) }} |
        %CH₄ = {{ formatNumberValue(data.data.percentageCH4) }}
      </template>
  </generic-triangle-print>
</template>

<script>
import polygonalChartTypes from '@/domain/enums/polygonalCharts/polygonalChart';
import duvalTriangleCoordinates from '@/domain/services/installation/engineering/chromatography/duvalTriangleCoordinates';
import GenericTrianglePrint from './GenericTriangle';

export default {
  name: 'Triangle1',
  props: {
    data: Object,
    norm: String,
  },
  components: {
    GenericTrianglePrint,
  },
  data: () => ({
    polygonalChartType: polygonalChartTypes.DUVAL_TRIANGLE_1,
  }),
  computed: {
    triangleCoordinates() {
      return duvalTriangleCoordinates
        .getTriangle1Coordinates(this.data.data);
    },
  },
  methods: {
    formatNumberValue(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return this.$n(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
  },
};

</script>
